import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PILOT_URL, MOBILE_ACCESS_URL, SIGN_IN_URL } from "./Header";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1628158088791-89567a8e84ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBwaG9uZXxlbnwwfHx8fDE3OTI4NzY2NjJ8MA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  return (
    <section data-testid="hero-section" className="relative overflow-hidden bg-navy">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-safety/10 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-40 -left-24 h-96 w-96 rounded-full bg-white/5 blur-3xl"
      />

      <div className="mx-auto grid max-w-6xl items-center gap-12 px-6 py-20 md:px-10 md:py-28 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <p
            data-testid="hero-eyebrow"
            className="mb-4 inline-block rounded-full border border-white/20 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-safety"
          >
            WSafe AI Mobile · WorkSafeAgent family
          </p>
          <h1
            data-testid="hero-headline"
            className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl"
          >
            Safety in your pocket.
          </h1>
          <p
            data-testid="hero-subline"
            className="mt-6 max-w-xl text-base leading-relaxed text-slate-200 sm:text-lg"
          >
            Snap a hazard, get a plain-language description, and send it to the
            person who can fix it. A competent person reviews every AI
            suggestion.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
            <a
              href={PILOT_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-pilot-button"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-safety px-7 py-3.5 text-base font-semibold text-white shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:bg-safety-dark"
            >
              Request the $1,000 founding paid pilot
              <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href={MOBILE_ACCESS_URL}
              data-testid="hero-mobile-access-button"
              className="inline-flex items-center justify-center rounded-full border border-white/40 px-7 py-3.5 text-base font-semibold text-white transition-colors duration-200 hover:bg-white/10"
            >
              Get mobile access
            </a>
            <a
              href={SIGN_IN_URL}
              data-testid="hero-sign-in-link"
              className="inline-flex items-center justify-center px-4 py-3.5 text-base font-semibold text-slate-200 transition-colors duration-200 hover:text-white"
            >
              Sign in
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
          className="relative"
        >
          <div className="overflow-hidden rounded-2xl border-4 border-safety/80 shadow-2xl">
            <img
              src={HERO_IMAGE}
              alt="Field worker using a phone on a job site"
              data-testid="hero-image"
              className="h-full w-full object-cover"
              loading="eager"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
